import React from "react";
import AInput from "../../../../common/formFeilds/customInput/AInput";
import { Col, Row } from "reactstrap";
import AAutoComplete from "../../../../common/form-fields-mui/AAutoComplete";
import { inputStyles, labelStyles, adjustmentFlagOptions } from "../utils";
import { LastUpdatedDetails } from "views/pages/manage/employeeManagement/userProfile/helper";

const ResultDetails = ({
  adjustmentFlag,
  setAdjustmentFlag,
  forResultUpdate,
  resultForm,
  setResultForm,
}) => {
  const fields = [
    { label: "Total Marks Obtained", value: "aesTotalMarks", type: "number" },
    { label: "Percentage", value: "percentage", type: "number" },
    { label: "Percentile", value: "percentile", type: "number" },
    { label: "Class", value: "classStudying", type: "number" }, //
    { label: "Stream", value: "stream", type: "text" },
    { label: "All India Rank", value: "aesAllIndRank", type: "number" },
  ];

  const handleChange = (key, value) => {
    setResultForm({ ...resultForm, [key]: value });
  };

  return (
    <>
      <h3 className="mt-2 mb-0">Results</h3>
      <Row>
        {fields?.map((field, idx) => (
          <Col md="4" key={idx}>
            <AInput
              labelStyle={labelStyles}
              style={inputStyles}
              label={field?.label}
              type={field?.type}
              value={resultForm?.[field?.value]}
              handler={(val) => handleChange(field.value, val)}
              disabled
              // disabled={!forResultUpdate}
            />
          </Col>
        ))}

        <Col md="4">
          <AAutoComplete
            label="Adjustment Flag"
            items={adjustmentFlagOptions}
            isMulti={false}
            labelStyle={labelStyles}
            style={{ control: inputStyles }}
            currentValue={adjustmentFlag}
            handleChange={(val) => setAdjustmentFlag(val)}
            isDisabled={!forResultUpdate}
          />
        </Col>

        {/* LastUpdatedDetails */}
        <Col md="4">
          <AInput
            labelStyle={labelStyles}
            style={inputStyles}
            label="Last Updated"
            value={LastUpdatedDetails(
              resultForm?.updatedOn,
              resultForm?.updatedBy
            )}
            disabled
          />
        </Col>
      </Row>
    </>
  );
};

export default ResultDetails;
